<template>
    <div>
        <div>
            <span class="label">{{ $t("pa.f1") }} *</span>
            <select class="inp" v-model="type">
                <option value="0">{{ $t("pa.o1") }}</option>
                <option value="1">{{ $t("pa.o2") }}</option>
            </select>
        </div>
        <!-- 个人 -->
        <div class="margin-top-50" v-show="type === '0'">
            <span class="label">{{ $t("pa.f2") }} *</span>
            <input v-model="email" class="inp" type="text" />
        </div>
        <div class="margin-top-50" v-show="type === '0'">
            <span class="label">{{ $t("pa.f3") }} *</span>
            <input v-model="username" class="inp" type="text" />
        </div>
        <div class="margin-top-50" v-show="type === '0'">
            <span class="label ">{{ $t("pa.f9") }} *</span>
            <input v-model="phone" class="inp" type="number" />
        </div>
        <!-- 企业 -->
        <div class="margin-top-50" v-show="type === '1'">
            <span class="label">{{ $t("pa.f4") }} *</span>
            <input v-model="email" class="inp" type="text" />
        </div>
        <div class="margin-top-50" v-show="type === '1'">
            <span class="label">{{ $t("pa.f5") }} *</span>
            <input v-model="name" class="inp" type="text" />
        </div>
        <div class="margin-top-50" v-show="type === '1'">
            <span class="label ">{{ $t("pa.f6") }} *</span>
            <select class="inp" v-model="businessType">
                <!-- <option value="1">营业执照</option>
                <option value="2">商业登记证</option> -->
                <option value="0">{{ $t("pa.f7") }}</option>
            </select>
        </div>
        <div class="margin-top-50" v-show="type === '1'">
            <span class="label">{{ $t("pa.f8") }} *</span>
            <input v-model="username" class="inp" type="text" />
        </div>
        <div class="margin-top-50" v-show="type === '1'">
            <span class="label">{{ $t("pa.f9") }} *</span>
            <input v-model="phone" class="inp" type="number" />
        </div>
        <!-- 国家 -->
        <div class="margin-top-50">
            <span class="label ">{{ $t("pa.f10") }} *</span>
            <select class="inp" v-model="countryId">
                <option
                    v-for="item in countryList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</option
                >
            </select>
        </div>
        <!-- 上传 -->
        <div class="upload-box">
            <div class="upload-wrap" v-show="type === '0'">
                <span class="label">{{ $t("pa.f11") }} *</span>
                <div class="up-btn">
                    <div class="up-btn-text" v-show="!frontIDCard">
                        {{ $t("pa.f13") }}
                    </div>
                    <img
                        class="up-btn-img"
                        v-show="frontIDCard"
                        :src="frontIDCard"
                        alt="img"
                    />
                    <input
                        type="file"
                        ref="frontIDCard"
                        @change="up('frontIDCard')"
                        class="up-btn-file"
                        accept="image/*"
                    />
                </div>
            </div>
            <div class="upload-wrap" v-show="type === '0'">
                <span class="label">{{ $t("pa.f12") }} *</span>
                <div class="up-btn">
                    <div class="up-btn-text" v-show="!reverseIDCard">
                        {{ $t("pa.f13") }}
                    </div>
                    <img
                        class="up-btn-img"
                        v-show="reverseIDCard"
                        :src="reverseIDCard"
                        alt="img"
                    />
                    <input
                        type="file"
                        ref="reverseIDCard"
                        @change="up('reverseIDCard')"
                        class="up-btn-file"
                        accept="image/*"
                    />
                </div>
            </div>
            <div class="upload-wrap" v-show="type === '1'">
                <span class="label">{{ $t("pa.f14") }} *</span>
                <div class="up-btn">
                    <div class="up-btn-text" v-show="!businessAttachment">
                        {{ $t("pa.f13") }}
                    </div>
                    <img
                        class="up-btn-img"
                        v-show="businessAttachment"
                        :src="businessAttachment"
                        alt="img"
                    />
                    <input
                        type="file"
                        ref="businessAttachment"
                        @change="up('businessAttachment')"
                        class="up-btn-file"
                        accept="image/*"
                    />
                </div>
            </div>
        </div>

        <div class="btn" @click="submit">
            {{ $t("pa.f15") }}
        </div>
    </div>
</template>
<script>
import axios from "@/http";
export default {
    data() {
        return {
            type: "0",
            countryList: [],
            countryId: 80,
            //身份证
            frontIDCard: null, //正面
            reverseIDCard: null, //反面
            email: "",
            phone: "",
            username: "",
            /**企业 */
            //营业登记图片
            businessAttachment: null,
            businessType: 0,
            name: "",
        };
    },
    created() {
        this.getCountry();
    },
    methods: {
        submit: async function() {
            let params;
            if (this.type == 0) {
                params = {
                    type: 0,
                    countryId: this.countryId,
                    email: this.email,
                    phone: this.phone,
                    username: this.username,
                    frontIDCard: this.frontIDCard,
                    reverseIDCard: this.reverseIDCard,
                };
            } else if (this.type == 1) {
                params = {
                    businessAttachment: this.businessAttachment,
                    businessType: this.businessType,
                    countryId: this.countryId,
                    email: this.email,
                    name: this.name,
                    phone: this.phone,
                    type: this.type,
                    username: this.username,
                };
            }
            const res = await axios.post("/api2/partner-register", params);
            if (res.code === 0) {
                this.$message({
                    message: "注册成功",
                    type: "success",
                    offset: 80,
                    duration: 5000,
                });
                this.frontIDCard = null;
                this.reverseIDCard = null;
                this.email = "";
                this.phone = "";
                this.username = "";
                this.businessAttachment = null;
                this.name = "";
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                    offset: 80,
                });
            }
            console.log(params);
        },
        getCountry: async function() {
            const res = await axios.get("/api2/country/names");
            // const res = await fetch("/api2/country/names");
            if (res.code === 0) {
                this.countryList = res.data;
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                    offset: 80,
                });
            }
        },
        async up(refName) {
            const file = this.$refs[refName].files[0];
            if (!file) return;
            const data = new FormData();
            data.append("file", file);
            const res = await axios.post("/api2/file/upload", data);
            if (res.code === 0) {
                this[refName] = res.data;
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                    offset: 80,
                });
            }
        },
    },
};
</script>
<style scoped>
.btn {
    background: #00a3d1;
    width: 140px;
    height: 50px;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    font-weight: bold;
    line-height: 50px;
    cursor: pointer;
    margin-top: 100px;
    float: right;
}
.inp {
    display: block;
    width: 100%;
    height: 50px;
    line-height: 55px;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    background: #ffffff;
    outline: none;
    font-size: 16px;
    color: rgba(51, 51, 51, 0.5);
    letter-spacing: 0;
}
.inp:focus {
    border-bottom: 1px solid rgba(0, 0, 0, 0.8);
    color: rgba(51, 51, 51, 0.8);
}
.label {
    display: inline-block;
    line-height: 22px;
    font-size: 16px;
    color: rgba(51, 51, 51, 0.5);
    letter-spacing: 0;
}
.margin-top-50 {
    margin-top: 50px;
}
.upload-box {
    margin-top: 50px;
}
.upload-wrap {
    display: inline-block;
    width: 280px;
}
.upload-wrap:nth-child(2) {
    margin-left: 35px;
}
.up-btn {
    margin-top: 19px;
    height: 80px;

    cursor: pointer;
    position: relative;
}
.up-btn-text {
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    line-height: 80px;
    background-color: rgba(0, 0, 0, 0.03);
}
.up-btn-img {
    display: block;
    width: 100%;
    height: 100%;
}
.up-btn-file {
    display: block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Partner/Form.vue